function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ScopeProvider, useFormRepeat } from '../../hooks/form';
export function FormRepeat(props) {
  var children = props.children,
      restProps = _objectWithoutProperties(props, ["children"]);

  var _useFormRepeat = useFormRepeat(restProps),
      scope = _useFormRepeat.scope,
      info = _objectWithoutProperties(_useFormRepeat, ["scope"]);

  return React.createElement(ScopeProvider, {
    value: scope
  }, typeof children === 'function' ? children(info) : children);
}